(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define("FormioExport", ["_", "moment"], factory);
	else if(typeof exports === 'object')
		exports["FormioExport"] = factory(require("lodash"), require("moment"));
	else
		root["FormioExport"] = factory(root["_"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__50__) {
return 